import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="accordion-2"
export default class extends Controller {
	connect() {
		this.panel = this.element.lastElementChild
		this.panel.classList.add("overflow-hidden", "transition-[max-height]", "duration-200", "ease-out", "max-h-0")
		this.element.dataset.action = "click->accordion-2#toggle"
	}

	toggle() {
		if (this.panel.style.maxHeight) {
			this.element.removeAttribute("data-ui")
			this.panel.style.maxHeight = null
		} else {
			this.element.dataset.ui = "open"
			this.panel.style.maxHeight = this.panel.scrollHeight + "px"
		}
	}
}
